import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
import { AdminPage } from "@/components/admin/AdminSidebar";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { OperacionesPanel } from "@/components/admin/datos/OperacionesPanel";
import { TiposLocalPanel } from "@/components/admin/datos/TiposLocalPanel";
import { UsosLocalPanel } from "@/components/admin/datos/UsosLocalPanel";
import { LicenciasPanel } from "@/components/admin/datos/LicenciasPanel";
import { DocumentoTiposPanel } from "@/components/admin/datos/DocumentoTiposPanel";
import { ImportarPanel } from "@/components/admin/datos/ImportarPanel";
import { ImportacionesPanel } from "@/components/admin/datos/ImportacionesPanel";
import { FusionarPanel } from "@/components/admin/datos/FusionarPanel";
import { DuplicadosPanel } from "@/components/admin/datos/DuplicadosPanel";
import { ExpiradosPanel } from "@/components/admin/datos/ExpiradosPanel";
import { VinculacionesPanel } from "@/components/admin/datos/VinculacionesPanel";
import { UbicacionesPanel } from "@/components/admin/datos/ubicaciones/UbicacionesPanel";
import { usePendientesCount } from "@/components/admin/datos/ubicaciones/use-pendientes";
import { Badge } from "@/components/ui/badge";

const searchSchema = z.object({ tab: z.string().optional() });

export const Route = createFileRoute("/admin/datos")({
  validateSearch: zodValidator(searchSchema),
  component: DatosPage,
});

function DatosPage() {
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const pendientes = usePendientesCount();
  return (
    <AdminPage
      title="Datos"
      description="Gestiona las entidades maestras del catálogo: operaciones, tipos y usos de local, licencias y ubicaciones."
    >
      <Tabs
        value={tab ?? "operaciones"}
        onValueChange={(v) => navigate({ search: { tab: v }, replace: true })}
        className="mt-2"
      >
        <TabsList className="h-auto flex-wrap">
          <TabsTrigger value="operaciones">Operaciones</TabsTrigger>
          <TabsTrigger value="tipos">Tipos de local</TabsTrigger>
          <TabsTrigger value="usos">Usos de local</TabsTrigger>
          <TabsTrigger value="licencias">Licencias</TabsTrigger>
          <TabsTrigger value="documento-tipos">Tipos de documento</TabsTrigger>
          <TabsTrigger value="importar">Importar</TabsTrigger>
          <TabsTrigger value="importaciones">Importaciones</TabsTrigger>
          <TabsTrigger value="vinculaciones">Vinculaciones</TabsTrigger>
          <TabsTrigger value="fusionar">Fusionar</TabsTrigger>
          <TabsTrigger value="duplicados">Duplicados</TabsTrigger>
          <TabsTrigger value="expirados">Expirados</TabsTrigger>
          <TabsTrigger value="ubicaciones" className="gap-2">
            Ubicaciones
            {!!pendientes.data && <Badge variant="destructive">{pendientes.data}</Badge>}
          </TabsTrigger>
        </TabsList>
        <TabsContent value="operaciones" className="mt-6">
          <OperacionesPanel />
        </TabsContent>
        <TabsContent value="tipos" className="mt-6">
          <TiposLocalPanel />
        </TabsContent>
        <TabsContent value="usos" className="mt-6">
          <UsosLocalPanel />
        </TabsContent>
        <TabsContent value="licencias" className="mt-6">
          <LicenciasPanel />
        </TabsContent>
        <TabsContent value="documento-tipos" className="mt-6">
          <DocumentoTiposPanel />
        </TabsContent>
        <TabsContent value="importar" className="mt-6">
          <ImportarPanel />
        </TabsContent>
        <TabsContent value="importaciones" className="mt-6">
          <ImportacionesPanel />
        </TabsContent>
        <TabsContent value="vinculaciones" className="mt-6">
          <VinculacionesPanel />
        </TabsContent>
        <TabsContent value="fusionar" className="mt-6">
          <FusionarPanel />
        </TabsContent>
        <TabsContent value="duplicados" className="mt-6">
          <DuplicadosPanel />
        </TabsContent>
        <TabsContent value="expirados" className="mt-6">
          <ExpiradosPanel />
        </TabsContent>
        <TabsContent value="ubicaciones" className="mt-6">
          <UbicacionesPanel />
        </TabsContent>
      </Tabs>
    </AdminPage>
  );
}
